import MatchedMap from 'utilities/src/matchedMap';

import type { InputThemeProps } from '../../../shared/utils/themes';

import { ThemeEnum, useTheme } from '../../../../Theme';

/**
 * Import Themes
 */

import inputTextCommonTheme from './common';

import inputTextBlogTheme from './_blog';
import inputTextSiteTheme from './_site';

/**
 * Group Themes
 */

const inputTextThemes = new MatchedMap([
  [ThemeEnum.Blog, inputTextBlogTheme],
  [ThemeEnum.Site, inputTextSiteTheme],
]);

/**
 * Theme Hook
 */

const useInputTextTheme = (fieldThemeProps: Pick<InputThemeProps, 'inputState'>) =>
  useTheme(inputTextCommonTheme(fieldThemeProps), inputTextThemes);

export default useInputTextTheme;
